export default __webpack_public_path__ + "static/media/service_cooolnetgbit.29739c64.svg";